import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { DollarSign, Repeat, Target, Star, CheckCircle } from "lucide-react";
export const BenefitsSection = () => {
  return <section className="py-12 md:py-16 lg:py-[60px]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4 lg:text-4xl">
            Por que escolher a{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-teal to-brand-coral">
              Conversion Bonus
            </span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto px-4">
            A solução completa para aumentar faturamento e construir relacionamentos duradouros
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-6xl mx-auto">
          <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow bg-white dark:bg-gray-800 p-4 md:p-6">
            <CardHeader>
              <div className="flex items-center gap-4 mb-4">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-brand-teal/10 rounded-lg flex items-center justify-center">
                  <DollarSign className="h-5 w-5 md:h-6 md:w-6 text-brand-teal" />
                </div>
                <CardTitle className="text-lg md:text-xl text-gray-900 dark:text-white">Aumento Direto no Faturamento</CardTitle>
              </div>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-sm md:text-base text-gray-600 dark:text-gray-300 mb-4">
                Clientes que recebem cashback compram 40% mais frequentemente e gastam 25% mais por compra.
              </CardDescription>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-xs md:text-sm text-gray-700 dark:text-gray-300">
                  <CheckCircle className="h-4 w-4 text-brand-teal flex-shrink-0" />
                  Ticket médio maior
                </li>
                <li className="flex items-center gap-2 text-xs md:text-sm text-gray-700 dark:text-gray-300">
                  <CheckCircle className="h-4 w-4 text-brand-teal flex-shrink-0" />
                  Compras mais frequentes
                </li>
                <li className="flex items-center gap-2 text-xs md:text-sm text-gray-700 dark:text-gray-300">
                  <CheckCircle className="h-4 w-4 text-brand-teal flex-shrink-0" />
                  ROI mensurável
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow bg-white dark:bg-gray-800 p-4 md:p-6">
            <CardHeader>
              <div className="flex items-center gap-4 mb-4">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-brand-coral/10 rounded-lg flex items-center justify-center">
                  <Repeat className="h-5 w-5 md:h-6 md:w-6 text-brand-coral" />
                </div>
                <CardTitle className="text-lg md:text-xl text-gray-900 dark:text-white">Crescimento Orgânico Escalável</CardTitle>
              </div>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-sm md:text-base text-gray-600 dark:text-gray-300 mb-4">
                Cada cliente satisfeito se torna um vendedor ativo, gerando indicações de alta qualidade automaticamente.
              </CardDescription>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-xs md:text-sm text-gray-700 dark:text-gray-300">
                  <CheckCircle className="h-4 w-4 text-brand-coral flex-shrink-0" />
                  Custo de aquisição reduzido
                </li>
                <li className="flex items-center gap-2 text-xs md:text-sm text-gray-700 dark:text-gray-300">
                  <CheckCircle className="h-4 w-4 text-brand-coral flex-shrink-0" />
                  Clientes mais qualificados
                </li>
                <li className="flex items-center gap-2 text-xs md:text-sm text-gray-700 dark:text-gray-300">
                  <CheckCircle className="h-4 w-4 text-brand-coral flex-shrink-0" />
                  Crescimento exponencial
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow bg-white dark:bg-gray-800 p-4 md:p-6">
            <CardHeader>
              <div className="flex items-center gap-4 mb-4">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-brand-teal/10 rounded-lg flex items-center justify-center">
                  <Target className="h-5 w-5 md:h-6 md:w-6 text-brand-teal" />
                </div>
                <CardTitle className="text-lg md:text-xl text-gray-900 dark:text-white">Automação Inteligente</CardTitle>
              </div>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-sm md:text-base text-gray-600 dark:text-gray-300 mb-4">
                Configure uma vez e deixe a plataforma trabalhar para você. WhatsApp integrado, regras personalizadas e relatórios automáticos.
              </CardDescription>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-xs md:text-sm text-gray-700 dark:text-gray-300">
                  <CheckCircle className="h-4 w-4 text-brand-teal flex-shrink-0" />
                  Mensagens automáticas
                </li>
                <li className="flex items-center gap-2 text-xs md:text-sm text-gray-700 dark:text-gray-300">
                  <CheckCircle className="h-4 w-4 text-brand-teal flex-shrink-0" />
                  Relatórios em tempo real
                </li>
                <li className="flex items-center gap-2 text-xs md:text-sm text-gray-700 dark:text-gray-300">
                  <CheckCircle className="h-4 w-4 text-brand-teal flex-shrink-0" />
                  Integração total
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow bg-white dark:bg-gray-800 p-4 md:p-6">
            <CardHeader>
              <div className="flex items-center gap-4 mb-4">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-brand-coral/10 rounded-lg flex items-center justify-center">
                  <Star className="h-5 w-5 md:h-6 md:w-6 text-brand-coral" />
                </div>
                <CardTitle className="text-lg md:text-xl text-gray-900 dark:text-white">Resultados Comprovados</CardTitle>
              </div>
            </CardHeader>
            <CardContent>
              <CardDescription className="text-sm md:text-base text-gray-600 dark:text-gray-300 mb-4">
                Centenas de e-commerces já aumentaram suas receitas usando nossos programas de fidelização e indicação.
              </CardDescription>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-xs md:text-sm text-gray-700 dark:text-gray-300">
                  <CheckCircle className="h-4 w-4 text-brand-coral flex-shrink-0" />
                  Cases de sucesso
                </li>
                <li className="flex items-center gap-2 text-xs md:text-sm text-gray-700 dark:text-gray-300">
                  <CheckCircle className="h-4 w-4 text-brand-coral flex-shrink-0" />
                  Suporte especializado
                </li>
                <li className="flex items-center gap-2 text-xs md:text-sm text-gray-700 dark:text-gray-300">
                  <CheckCircle className="h-4 w-4 text-brand-coral flex-shrink-0" />
                  Garantia de resultado
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
};